/**
 * @author Ivan Toth.
 */
var DetailSamplingEditController = (function () {
    function DetailSamplingEditController(topic, env) {
        this.topic = topic;
        this.env = env;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_4 = 4;
        this.uiVersion = this.topic.checksData.uiVersion;
    }
    ;
    DetailSamplingEditController.prototype.addComment = function () {
        //Here to add the comment into the server
        this.topic.clearTempComments();
        alert('Adding a comment');
    };
    DetailSamplingEditController.$inject = ['topic', 'env'];
    return DetailSamplingEditController;
}());
var DetailSamplingEditComponent = (function () {
    function DetailSamplingEditComponent() {
        this.templateUrl = 'detail-sampling.html';
        this.controllerAs = 'vm';
        this.controller = DetailSamplingEditController;
    }
    return DetailSamplingEditComponent;
}());
angular
    .module('application')
    .component('detailSamplingEdit', new DetailSamplingEditComponent());

//# sourceMappingURL=detail.sampling.edit.component.js.map
